import store from '@/store/index';
/**
 * Is responsible for redrawing the map based on store data,
 * one can reason about it as a single point of entry map manipuplation class
 */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
/*eslint-disable */
import MapService from '@/services/MapService';
import { Layer, LayerGroup } from 'leaflet';
import { toRaw } from 'vue';
import { LayerControlEnum } from '@/enums/LayerControlEnum';

export default class RedrawService {
  private mapService: MapService;

  private parkingSpotsBreakpointZoomFactor: number = 19;
  private zoneMarkerBreakpointZoomFactor: number = 13;
  private zoneMarkerVisibleGroup: any = {
    from: 17,
    to: 18,
  };
  private zoomMarkerVisibleMeters: number = 17;
  private zoomMarkerVisibleTrafficPoints: number = 14;

  constructor(mapService: MapService) {
    this.mapService = mapService;
  }
  /**
   * Redraws everything on the map.
   */
  public redrawMap = (): void => {
    const { map } = store.state.settings;
    this.removeLayersBeforeRedraw();

    if (map[LayerControlEnum.SHOW_PARKINGS]) {
      this.redrawParkings();
    }
    if (map[LayerControlEnum.SHOW_PARKING_ZONES]) {
      this.redrawParkingZones();
    }
    if (map[LayerControlEnum.SHOW_PARKING_METERS]) {
      this.redrawParkingMeters();
    }
    if (map[LayerControlEnum.SHOW_PARKING_SPOTS]) {
      this.redrawParkingSpots();
    }
    if (map[LayerControlEnum.SHOW_PARKING_BOARDS]) {
      this.redrawParkingBoards();
    }
    if ( map[LayerControlEnum.SHOW_PARKING_GROUPS]) {
      this.redrawParkingGroups();
    }
    if (map[LayerControlEnum.SHOW_VMS]) {
      this.redrawVmsBoards();
    }
    if (map[LayerControlEnum.SHOW_CAM]) {
      this.redrawFixedCameras();
      this.redrawPtzCameras();
    }
    if (map[LayerControlEnum.SHOW_TRAFFIC]) {
      this.redrawTraffic();
      this.redrawTrafficPoints();
    }
    const eventsSwicherValues = Object.values(store.state.settings.mapEventLayers);
    if (eventsSwicherValues.includes(true)) {
      this.redrawEvents();
    }
    const poiSwicherValues = Object.values(store.state.settings.mapPoiLayers);
    if (poiSwicherValues.includes(true)) {
      this.redrawPoi();
    }
    
    if (map[LayerControlEnum.SHOW_TRACKS]) {
      this.redrawTrackStartPoints();
    }
    const { isSelectedStartPoint} = store.state.tracks;
    const { trackLines} = store.state;

    if (isSelectedStartPoint) {
      this.redrawTrackEndPoints();
    }

    if (isSelectedStartPoint && trackLines.length) {
      this.redrawTrackLines();
    }
    if (map[LayerControlEnum.SHOW_WEATHER_STATIONS]) {
      this.redrawWeatherStations();
    }
    if (map[LayerControlEnum.SHOW_BIKE_STATIONS]) {
      this.redrawBikeStations();
    }
    if (map[LayerControlEnum.SHOW_RADARS]) {
      this.redrawRadarBoards();
    }
  };

  public redrawOnlyParkingGroups = (): void => {
    this.redrawParkingGroups();
  };
  
  public redrawOnlyTrafficLines = (): void => {
    this.redrawTraffic();
  };

  public redrawOnlyTrackLines = (): void => {
    this.redrawTrackLines();
  };
 
  /**
   * Removes layers from the map.
   */
  private removeLayersBeforeRedraw = (): void => {
    const { leafletLayers } = store.state;

    Object.values(leafletLayers).forEach((layer) => {
        if (layer instanceof Layer) {
          layer.remove(); // Remove all layers, regardless of type
        }
    });

    // Optionally clear the tracked layers after removing them
    // store.state.leafletLayers = {};
};

  /**
   * Redraws parking spots on the map.
   * zoom 0 do 15 - parkingi
   */
  private redrawParkings = (): void => {
    const oldLayer = toRaw(store.state.leafletLayers.parkingLayer);
    
    try {
      store.commit('updateParkingsLayerGroup', this.mapService.drawParkingsMarkers());
    } catch (e) {
      console.error('Redraw failed! - parkings couldn\'t been drawn'); // eslint-disable-line no-console
      console.error(e); // eslint-disable-line no-console
    }
    if (oldLayer instanceof LayerGroup) {
      oldLayer.remove();
    }
  };

  // /**
  //  * Redraws parking zones on the map.
  //  */
  private redrawParkingZones = (): void => {
    const oldParkingZonesLayer = store.state.leafletLayers.parkingZones;
    if (store.state.zoomFactor >= this.zoneMarkerBreakpointZoomFactor) {
      try {
        store.commit('updateParkingZonesLayerGroup', this.mapService.drawParkingZonesPolygons());
      } catch (e) {
        console.error('Redraw failed! - parking zones couldn\'t been drawn'); // eslint-disable-line no-console
        console.error(e); // eslint-disable-line no-console
      }
    } else {
      // try {
      //   store.commit('updateParkingZonesMarkersLayerGroup', this.mapService.drawParkingZonesMarkers());
      // } catch (e) {
      //   console.error('Redraw failed! - parking zones markers couldn\'t been drawn'); // eslint-disable-line no-console
      //   console.error(e); // eslint-disable-line no-console
      // }
    }
    if (oldParkingZonesLayer instanceof LayerGroup) {
      oldParkingZonesLayer.remove();
    }
  };

  /**
   * Redraws parking meters on the map.
   */
  private redrawParkingMeters = (): void => {
    const oldLayer = store.state.leafletLayers.parkingMeters;
    // if (store.state.zoomFactor >= this.zoomMarkerVisibleMeters) {
      try {
        store.commit('updateParkingMetersLayerGroup', this.mapService.drawParkingMetersMarkers());
      } catch (e) {
        console.error('Redraw failed! - parking meters couldn\'t been drawn'); // eslint-disable-line no-console
        console.error(e); // eslint-disable-line no-console
      }
    // }
    if (oldLayer instanceof LayerGroup) {
      oldLayer.remove();
    }
  };

  private redrawParkingBoards = (): void => {
    const oldLayer = store.state.leafletLayers.parkingBoards;
    // if (store.state.zoomFactor >= this.zoomMarkerVisibleMeters) {
      try {
        store.commit('updateParkingBoardsLayerGroup', this.mapService.drawParkingBoardsMarkers());
      } catch (e) {
        console.error('Redraw failed! - parking boards couldn\'t been drawn'); // eslint-disable-line no-console
        console.error(e); // eslint-disable-line no-console
      }
    // }
    if (oldLayer instanceof LayerGroup) {
      oldLayer.remove();
    }
  };

  /**
   * Redraws parking spots on the map.
   * zoom 19 + - miejsca parkingowe
   */
  private redrawParkingSpots = ():void => {
    const oldLayer = store.state.leafletLayers.parkingSpots;
    if (store.state.zoomFactor >= this.parkingSpotsBreakpointZoomFactor) {
      try {
        store.commit('updateParkingSpotsLayerGroup', this.mapService.drawParkingSpotsMarkers());
      } catch (e) {
        console.error('Redraw failed! - parking spots couldn\'t been drawn'); // eslint-disable-line no-console
        console.error(e); // eslint-disable-line no-console
      }
    }
    if (oldLayer instanceof LayerGroup) {
      oldLayer.remove();
    }
  };

  /**
   * Redraws parking group on the map.
   * 
   */
  private redrawParkingGroups = ():void => {
    const oldLayer = store.state.leafletLayers.parkingGroups;
    try {
      store.commit('updateParkingGroupsLayerGroup', this.mapService.drawParkingGroupsPolygons());
    } catch (e) {
      console.error('Redraw failed! - parking groups couldn\'t been drawn'); // eslint-disable-line no-console
      console.error(e); // eslint-disable-line no-console
    }
    if (oldLayer instanceof LayerGroup) {
      oldLayer.remove();
    }
  };

  /**
   * Redraws  EVENTS - on the map.
   */
  private redrawEvents = ():void => {
    const oldLayer = store.state.leafletLayers.events;
    try {
      store.commit('updateEventsLayerGroup', this.mapService.drawEventsMarkers());
    } catch (e) {
      console.error('Redraw failed! - events couldn\'t been drawn'); // eslint-disable-line no-console
      console.error(e); // eslint-disable-line no-console
    }
    if (oldLayer instanceof LayerGroup) {
      oldLayer.remove();
    }
  };
  /**
   * Redraws parking WEATHER group on the map.
   */
  private redrawWeatherStations = ():void => {
    const oldLayer = store.state.leafletLayers.weatherStations;
    try {
      store.commit(
        'updateWeatherStationsLayerGroup',
        this.mapService.drawWeatherStationsMarkers(),
      );
    } catch (e) {
      console.error('Redraw failed! - weather stations couldn\'t been drawn'); // eslint-disable-line no-console
      console.error(e); // eslint-disable-line no-console
    }
    if (oldLayer instanceof LayerGroup) {
      oldLayer.remove();
    }
  };

  /**
   * Redraws VMS boards group on the map.
   */
  private redrawVmsBoards = ():void => {
    const oldLayer = store.state.leafletLayers.vmsBoards;
    try {
      store.commit(
        'updateVmsBoardsLayerGroup',
        this.mapService.drawVmsBoardsMarkers(),
      );
    } catch (e) {
      console.error('Redraw failed! - VMS boards couldn\'t been drawn'); // eslint-disable-line no-console
      console.error(e); // eslint-disable-line no-console
    }
    if (oldLayer instanceof LayerGroup) {
      oldLayer.remove();
    }
  };

  /**
   * Redraws markers Cameras - fixed on the map.
   */
   private redrawFixedCameras = ():void => {
    const oldLayer = store.state.leafletLayers.cctvFixedCameras;
    try {
      store.commit('updateCctvFixedCamerasLayerGroup', this.mapService.drawCamerasMarkers('fixed'));
    } catch (e) {
      console.error('Redraw failed! - FIXED cameras couldn\'t been drawn'); // eslint-disable-line no-console
      console.error(e); // eslint-disable-line no-console
    }
    if (oldLayer instanceof LayerGroup) {
      oldLayer.remove();
    }
  };

  /**
   * Redraws markers Cameras - fixed on the map.
   */
   private redrawPtzCameras = ():void => {
    const oldLayer = store.state.leafletLayers.cctvPtzCameras;
    try {
      store.commit('updateCctvPtzCamerasLayerGroup', this.mapService.drawCamerasMarkers('ptz'));
    } catch (e) {
      console.error('Redraw failed! - PTZ cameras couldn\'t been drawn'); // eslint-disable-line no-console
      console.error(e); // eslint-disable-line no-console
    }
    if (oldLayer instanceof LayerGroup) {
      oldLayer.remove();
    }
  };

  /**
   * Redraws traffic polylines on the map.
   */
   private redrawTraffic = ():void => {
    const oldLayer = store.state.leafletLayers.trafficLayer;
    try {
      store.commit('updateTrafficLayerGroup', this.mapService.drawTrafficPolyLines());
    } catch (e) {
      console.error('Redraw failed! - traffic layer couldn\'t been drawn'); // eslint-disable-line no-console
      console.error(e); // eslint-disable-line no-console
    }
    if (oldLayer instanceof LayerGroup) {
      oldLayer.remove();
    }
  };

  /**
   * Redraws traffic points on the map.
   */
   private redrawTrafficPoints = ():void => {
    const oldLayer = store.state.leafletLayers.trafficPointsLayer;
    if (store.state.zoomFactor >= this.zoomMarkerVisibleTrafficPoints) {
      try {
        store.commit(
          'updateTrafficPointsLayerGroup',
          this.mapService.drawTrafficPoints(),
        );
      } catch (e) {
        console.error('Redraw failed! - Traffic points couldn\'t been drawn'); // eslint-disable-line no-console
        console.error(e); // eslint-disable-line no-console
      }
    }
    if (oldLayer instanceof LayerGroup) {
      oldLayer.remove();
    }
  };

  /**
   * Redraws POI points group on the map.
   */
   private redrawPoi = ():void => {
    const oldLayer = store.state.leafletLayers.poiPointsLayer;
    try {
      store.commit(
        'updatePoiPointsLayerGroup',
        this.mapService.drawPoiMarkers(),
      );
    } catch (e) {
      console.error('Redraw failed! - POI points couldn\'t been drawn'); // eslint-disable-line no-console
      console.error(e); // eslint-disable-line no-console
    }
    if (oldLayer instanceof LayerGroup) {
      oldLayer.remove();
    }
  };

  /**
   * Redraws track start points group on the map.
   */
  private redrawTrackStartPoints = ():void => {
    const oldLayer = store.state.leafletLayers.trackStartPointsLayer;
    try {
      store.commit(
        'updateTrackStartPointsLayerGroup',
        this.mapService.drawTrackStartPoints(),
      );
    } catch (e) {
      console.error('Redraw failed! - track start points couldn\'t been drawn'); // eslint-disable-line no-console
      console.error(e); // eslint-disable-line no-console
    }
    if (oldLayer instanceof LayerGroup) {
      oldLayer.remove();
    }
  };

  /**
  * Redraws track start points group on the map.
  */
  public redrawTrackEndPoints = ():void => {
    const oldLayer = store.state.leafletLayers.trackEndPointsLayer;
    try {
      store.commit(
        'updateTrackEndPointsLayerGroup',
        this.mapService.drawTrackEndPoints(),
      );
    } catch (e) {
      console.error('Redraw failed! - track end points couldn\'t been drawn'); // eslint-disable-line no-console
      console.error(e); // eslint-disable-line no-console
    }
    if (oldLayer instanceof LayerGroup) {
      oldLayer.remove();
    }
  };

  /**
  * Redraws track lines on the map.
  */
  public redrawTrackLines = (): void => {
    const oldLayer = store.state.leafletLayers.trackLinesLayer;
    try {
      store.commit(
        'updateTrackLinesLayerGroup',
        this.mapService.drawTrackLines(),
      );
    } catch (e) {
      console.error('Redraw failed! - track lines couldn\'t be drawn', e);
    }

    if (oldLayer instanceof LayerGroup) {
      oldLayer.remove(); // Use clearLayers instead of remove
    }
  };

  private redrawBikeStations = ():void => {
    const oldLayer = store.state.leafletLayers.bikeStations;
    try {
      store.commit(
        'updateBikeStationsLayerGroup',
        this.mapService.drawBikeStationsMarkers(),
      );
    } catch (e) {
      console.error('Redraw failed! - bike stations couldn\'t been drawn'); // eslint-disable-line no-console
      console.error(e); // eslint-disable-line no-console
    }
    if (oldLayer instanceof LayerGroup) {
      oldLayer.remove();
    }
  };
  private redrawRadarBoards = ():void => {
    const oldLayer = store.state.leafletLayers.radarBoards;
    try {
      store.commit(
        'updateRadarBoardsLayerGroup',
        this.mapService.drawRadarBoardsMarkers(),
      );
    } catch (e) {
      console.error('Redraw failed! - radar boards couldn\'t been drawn'); // eslint-disable-line no-console
      console.error(e); // eslint-disable-line no-console
    }
    if (oldLayer instanceof LayerGroup) {
      oldLayer.remove();
    }
  };


  /**
   * fetches data from the api and redraws the map
   */
  // public updateAndRedraw = (): Promise<unknown> => new Promise<unknown>((resolve, reject) => {
  //   Promise.all([
  //     store.dispatch('updateParkings'),
  //     store.dispatch('updateParkingZones'),
  //     store.dispatch('updateParkingMeters'),
  //     store.dispatch('updateParkingSpots'),
  //     store.dispatch('updateParkingGroups'),
  //     store.dispatch('updateEvents'),
  //     // store.dispatch('updateCurrentWeather'),
  //     // store.dispatch('updateWeatherStations'),
  //     store.dispatch('updateVmsBoards'),
  //     store.dispatch('updateCameras'),
  //     store.dispatch('updateTraffic'),
  //     store.dispatch('updatePoiLayers'),
  //     store.dispatch('updatePoiPoints'),
  //     store.dispatch('updateOpenWeather'),
  //     store.dispatch('updateTrackStartPoints'),
  //   ])
  //     .then(() => {
  //       this.redrawMap();
  //       resolve(true);
  //     })
  //     .catch(reject);
  // });

  public initDataAndRedraw = (): Promise<unknown> => new Promise<unknown>((resolve, reject) => {
    const { map } = store.state.settings;
    const promises = [];

    // promises.push(store.dispatch('updateOpenWeather'));
    promises.push(store.dispatch('updateTrackStartPoints'));

    if (map[LayerControlEnum.SHOW_PARKINGS]) {
      promises.push(store.dispatch('updateParkings'));
    }
    if (map[LayerControlEnum.SHOW_PARKINGS]) {
      promises.push(store.dispatch('updateParkingSpots'));
    }
    if (map[LayerControlEnum.SHOW_PARKINGS]) {
      promises.push(store.dispatch('updateParkingGroups'));
    }
    if (map[LayerControlEnum.SHOW_PARKINGS]) {
      promises.push(store.dispatch('updateParkingZones'));
    }
    if (map[LayerControlEnum.SHOW_PARKING_METERS]) {
      promises.push(store.dispatch('updateParkingMeters'));
      promises.push(store.dispatch('updateParkingZones'));
    }
    if (map[LayerControlEnum.SHOW_PARKING_BOARDS]) {
      promises.push(store.dispatch('updateParkingBoards'));
    }
    if (map[LayerControlEnum.SHOW_VMS]) {
      promises.push(store.dispatch('updateVmsBoards'));
    }
    if (map[LayerControlEnum.SHOW_CAM]) {
      promises.push(store.dispatch('updateCameras'));
    }
    if (map[LayerControlEnum.SHOW_TRAFFIC]) {
      promises.push(store.dispatch('updateTraffic'));
    }
    if (map[LayerControlEnum.SHOW_WEATHER_STATIONS]) {
      promises.push(store.dispatch('updateWeatherStations'));
    }
    if (map[LayerControlEnum.SHOW_BIKE_STATIONS]) {
      promises.push(store.dispatch('updateBikeStations'));
    }
    if (map[LayerControlEnum.SHOW_RADARS]) {
      promises.push(store.dispatch('updateRadarBoards'));
    }
  
    promises.push(store.dispatch('updatePoiLayers'));
    promises.push(store.dispatch('updatePoiPoints'));

    promises.push(store.dispatch('updateEventCategories'));
    promises.push(store.dispatch('updateEvents'));

    Promise.all(promises)
      .then(() => {
        this.redrawMap();
        resolve(true);
      })
      .catch(reject);
  });

  public updateDynamicDataAndRedraw = (): Promise<unknown> => new Promise<unknown>((resolve, reject) => {
    const { map } = store.state.settings;
    const promises = [];

    if (map[LayerControlEnum.SHOW_PARKINGS]) {
      promises.push(store.dispatch('updateParkings'));
    }
    if (map[LayerControlEnum.SHOW_PARKINGS]) {
      promises.push(store.dispatch('updateParkingSpots'));
    }
    if (map[LayerControlEnum.SHOW_PARKINGS]) {
      promises.push(store.dispatch('updateParkingGroups'));
    }
    if (map[LayerControlEnum.SHOW_PARKINGS]) {
      promises.push(store.dispatch('updateParkingZones'));
    }
    if (map[LayerControlEnum.SHOW_PARKING_METERS]) {
      promises.push(store.dispatch('updateParkingMeters'));
      promises.push(store.dispatch('updateParkingZones'));
    }
    if (map[LayerControlEnum.SHOW_PARKING_BOARDS]) {
      promises.push(store.dispatch('updateParkingBoards'));
    }
    if (map[LayerControlEnum.SHOW_TRAFFIC]) {
      promises.push(store.dispatch('updateTraffic'));
      promises.push(store.dispatch('updateTrafficPoints'));
    }
    if (map[LayerControlEnum.SHOW_WEATHER_STATIONS]) {
      promises.push(store.dispatch('updateWeatherStations'));
    }
  
    if (map[LayerControlEnum.SHOW_BIKE_STATIONS]) {
      promises.push(store.dispatch('updateBikeStations'));
    }
    if (map[LayerControlEnum.SHOW_RADARS]) {
      promises.push(store.dispatch('updateRadarBoards'));
    }
  
    // promises.push(store.dispatch('updateOpenWeather'));
    

    Promise.all(promises)
      .then(() => {
        this.redrawMap();
        resolve(true);
      })
      .catch(reject);
  });
}
